/**
 * Onglets du détail d'un workflow (« Backfills » depuis le 2026-10-10, « Historique » des définitions
 * depuis le 2026-11-04, ADR 0102 §6).
 * Le legacy (`workflow-details.component.html`) n'a pas d'onglet Définition séparé — étapes et
 * planification vivent dans le résumé. L'onglet actif vit dans l'URL (`?tab=`).
 */
export const WORKFLOW_TABS = [
  'summary',
  'runs',
  'history',
  'backfills',
  'notifications',
  'costs',
  'permissions',
] as const;
export type WorkflowTab = (typeof WORKFLOW_TABS)[number];

export const isWorkflowTab = (value: unknown): value is WorkflowTab =>
  typeof value === 'string' && (WORKFLOW_TABS as readonly string[]).includes(value);
